import { Dialog, Transition } from "@headlessui/react";
import { Fragment, JSX, ReactElement, SetStateAction } from "react";

interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: SetStateAction<boolean>) => void;
  title: string;
  children?: ReactElement | JSX.Element[];
  size?: string;
  dir?: string;
  index?: number;
  className?: string;
}

export default function Modal({
  isOpen,
  setIsOpen,
  title,
  children,
  size = "md",
  dir = "ltr",
  className,
}: Props) {
  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className={`relative z-20 `}
        onClose={closeModal}
        key={title}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className={`fixed  inset-0 bg-black/25`} />
        </Transition.Child>

        <div className={`fixed inset-0 overflow-y-auto  `}>
          <div className="flex min-h-full items-center  justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className={`${className || `w-${size}`} relative transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all`}
                dir={dir}
              >
                {children}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
